import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import { BiData, DeviationEditClickBiEvent } from '@wix/da-bi/pkg/events';
import SolidButton, {
  Props as SolidButtonProps,
} from '@wix/da-ds/pkg/Buttons/SolidButton/SolidButton';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import { useEditDeviationAction } from '../../../actionHooks/useEditDeviationAction';

interface Props
  extends Omit<
    SolidButtonProps,
    'variant' | 'size' | 'onClick' | 'children' | 'biData'
  > {
  deviation: PapiDeviation;
}

const EditButton: React.FC<Props> = ({ deviation, ...rest }) => {
  const { t } = useTranslation();
  const onClick = useEditDeviationAction(deviation);
  return (
    <SolidButton
      variant="main"
      size="medium"
      onClick={onClick}
      biData={BiData<DeviationEditClickBiEvent>({
        evid: 371,
        typeid: getDeviationResourceType(deviation),
        itemid: deviation.deviationId,
      })}
      {...rest}
    >
      {t('actionbar.stash.editDraft')}
    </SolidButton>
  );
};

EditButton.displayName = 'EditButton';

export default EditButton;
